import * as React from 'react'
import { times } from 'lodash';
import DataTable from 'react-data-table-component'
import { Switch } from '@material-ui/core'
import SidebarContainer from 'src/modules/Routing/Sidebar/SidebarContainer'
import AlertTableDetails from './components/AlertTableDetails'
import { AlertsService } from 'src/share/services/alerts'
import ConfirmationModal from 'src/share/components/ConfirmationModal/ConfirmationModal';
import AlertControlSubHeader from './components/AlertControlSubHeader';
import AlertStatusModal from './components/AlertStatusModal';
import { getAlertStatusColor } from './components/AlertHistoryRow';
import { timestampToDateTimeString } from 'src/share/utils/utils';
import { columns } from './utils/columns';
import useDebounce from 'src/share/hooks/useDebounce';
import './AlertControlCenter.css'
import { RoutesModules } from 'src/modules/Routing/types';

const AlertControlCenter = (): React.ReactElement => {
  const [search, setSearch] = React.useState({ size: 10, page: 0, total: 0, status: [], sort: [{ createdAt: { order: 'desc' } }] });
  const [alerts, setAlerts] = React.useState<any[]>([]);
  const [isBanModalActive, setIsBanModalActive] = React.useState(false);
  const [isStatusModalActive, setIsStatusModalActive] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const [alertSelected, setAlertSelected] = React.useState('');
  const [filterText, setFilterText] = React.useState("");
  const debouncedSFilterText = useDebounce(filterText, 500);
  const loadingArray = React.useRef(times(10, Object));
  React.useEffect(() => {
    fetchAlerts();
  }, [debouncedSFilterText, search.page, search.size, search.status]);
  async function fetchAlerts() {
    const request = {
      sort: search.sort,
      page: search.page,
      size: search.size,
      status: search.status,
      queryString: debouncedSFilterText
    };
    setLoading(true);
    const { results, total }: any = await AlertsService.status(request);
    const fetchedAlerts = results.reduce(transformAlertData, []);
    setSearch(prevSearch => ({ ...prevSearch, total }));
    setAlerts(fetchedAlerts);
    setLoading(false);
  }
  function transformAlertData(alertList, alert) {
    const alertControl = {
      caseId: alert.caseId,
      id: alert.alertId,
      banned: !!alert.banned,
      child: alert.children[0].fullName,
      createdAt: timestampToDateTimeString(alert.createdAt),
      country: alert.countryName,
      status: <div><span className={`circle bg-${getAlertStatusColor(alert.status)}`} />{` ${alert.status}`}</div>,
      sendErrorEmailSwitch: <Switch color="primary" checked={!!alert.banned} onClick={() => handleBanModalToggled(alert.alertId)} />,
    };
    return [...alertList, alertControl];
  }
  function getModalDescription(): string {
    const alertData = alerts.find(alert => alert.id === alertSelected);
    return alertData && `Do you want to ${!alertData.banned ? 'continue' : 'stop'} receiving emails for this alert?`
  }
  function switchBanStatus(alertId: string, newAlerts: any[]) {
    const alertToBanIndex = newAlerts.findIndex(alert => alert.id === alertId) as any;
    newAlerts[alertToBanIndex].banned = !newAlerts[alertToBanIndex].banned;
    newAlerts[alertToBanIndex].sendErrorEmailSwitch = <Switch color="primary" checked={newAlerts[alertToBanIndex].banned} onChange={() => handleBanModalToggled(newAlerts[alertToBanIndex].id)} />
    return newAlerts;
  }
  const handleAlertBanned = async () => {
    setIsBanModalActive(prevSearch => !prevSearch);
    const alertData = alerts.find(alert => alert.id === alertSelected);
    await AlertsService.handleBanAlertStatus(alertSelected, alertData.banned);
    setAlertSelected('');
  }
  const handleFilltersApplied = (filters): void => {
    setIsStatusModalActive(false);
    setSearch(prevSearch => ({ ...prevSearch, status: filters }));
  };
  const handleBanModalToggled = (alertId?: string) => {
    setAlerts(prevAlerts => switchBanStatus(alertId || alertSelected, [...prevAlerts]));
    setAlertSelected(alertId || '');
    setIsBanModalActive(prevCheck => !prevCheck)
  }
  const handleStatusModalToggled = (): void => setIsStatusModalActive(!isStatusModalActive);
  return (
    <div className="alert-control-center__container white-background">
      <h1>Alert Control Center</h1>
      <DataTable
        columns={columns(loading)}
        data={loading ? loadingArray.current : alerts}
        noHeader={true}
        fixedHeader={true}
        subHeader={true}
        subHeaderComponent={<AlertControlSubHeader onSearch={setFilterText} filterText={filterText} onStatusModalToggle={handleStatusModalToggled} />}
        highlightOnHover={true}
        className="data-table__container"
        expandableRows={true}
        expandOnRowClicked={true}
        pagination={true}
        paginationServer={true}
        paginationTotalRows={search.total}
        onChangeRowsPerPage={(size, page) => setSearch(prevSearch => ({ ...prevSearch, size, page }))}
        onChangePage={(page) => setSearch(prevSearch => ({ ...prevSearch, page: page - 1 }))} // It starts counting on 0.
        expandableRowsComponent={!loading ? <AlertTableDetails /> : <></>}
      />
      <AlertStatusModal isActive={isStatusModalActive} onToggle={handleStatusModalToggled} onApply={handleFilltersApplied} />
      <ConfirmationModal
        isOpen={isBanModalActive}
        toggle={(): void => handleBanModalToggled()}
        title={'FIA alert status email'}
        description={getModalDescription()}
        onContinue={handleAlertBanned}
      />
    </div>
  )
}

export default SidebarContainer(RoutesModules.ALERTS)(AlertControlCenter);



// WEBPACK FOOTER //
// ./src/modules/Alert/ControlCenter/AlertControlCenter.tsx